module.exports = __webpack_public_path__ + "static/media/fotoabout.5c474cfa.png";